import { IApplicationState } from '../../types/redux';

/**
 * Выбирает всю pageMeta
 */
export const selectPageMetaItems = ({ pagesMeta }: IApplicationState) => pagesMeta.items;
